var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"layout generic-error-layout"},[_vm._v("\n  There is no layout defined for the site or page\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }